import type { ReactNode } from 'react';
import { Button, Spinner, type ButtonRootProps } from '@heroui/react';

export type AsyncButtonProps = ButtonRootProps & {
  /** True enquanto a ação assíncrona está em andamento. */
  isPending?: boolean;
  /**
   * Texto mantido durante o loading (com spinner à esquerda).
   * Se omitido e `children` for string/número, reutiliza o children.
   */
  pendingLabel?: ReactNode;
};

/**
 * Button com feedback de loading para HeroUI 3 (sem prop isLoading nativa).
 * Mantém o rótulo visível e mostra Spinner no lugar do ícone/conteúdo idle.
 */
export function AsyncButton({
  isPending = false,
  pendingLabel,
  isDisabled,
  children,
  ...props
}: AsyncButtonProps) {
  const labelWhilePending =
    pendingLabel ??
    (typeof children === 'string' || typeof children === 'number' ? children : null);

  return (
    <Button type="button" isDisabled={isDisabled || isPending} {...props}>
      {isPending ? (
        <>
          <Spinner size="sm" color="current" className="shrink-0" />
          {labelWhilePending}
        </>
      ) : (
        children
      )}
    </Button>
  );
}
